// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import type { OperationOptions } from "@azure-rest/core-client";

/** Optional parameters. */
export interface WorkloadNetworksDeleteVMGroupOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface WorkloadNetworksUpdateVMGroupOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface WorkloadNetworksCreateVMGroupOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface WorkloadNetworksGetVMGroupOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface WorkloadNetworksListVMGroupsOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface WorkloadNetworksGetVirtualMachineOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface WorkloadNetworksListVirtualMachinesOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface WorkloadNetworksDeleteSegmentOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface WorkloadNetworksUpdateSegmentsOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface WorkloadNetworksCreateSegmentsOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface WorkloadNetworksGetSegmentOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface WorkloadNetworksListSegmentsOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface WorkloadNetworksDeletePublicIPOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface WorkloadNetworksCreatePublicIPOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface WorkloadNetworksGetPublicIPOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface WorkloadNetworksListPublicIPsOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface WorkloadNetworksDeletePortMirroringOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface WorkloadNetworksUpdatePortMirroringOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface WorkloadNetworksCreatePortMirroringOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface WorkloadNetworksGetPortMirroringOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface WorkloadNetworksListPortMirroringOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface WorkloadNetworksGetGatewayOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface WorkloadNetworksListGatewaysOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface WorkloadNetworksDeleteDnsZoneOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface WorkloadNetworksUpdateDnsZoneOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface WorkloadNetworksCreateDnsZoneOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface WorkloadNetworksGetDnsZoneOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface WorkloadNetworksListDnsZonesOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface WorkloadNetworksDeleteDnsServiceOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface WorkloadNetworksUpdateDnsServiceOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface WorkloadNetworksCreateDnsServiceOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface WorkloadNetworksGetDnsServiceOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface WorkloadNetworksListDnsServicesOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface WorkloadNetworksDeleteDhcpOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface WorkloadNetworksUpdateDhcpOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface WorkloadNetworksCreateDhcpOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface WorkloadNetworksGetDhcpOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface WorkloadNetworksListDhcpOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface WorkloadNetworksListOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface WorkloadNetworksGetOptionalParams extends OperationOptions {}
